import { render, staticRenderFns } from "./TenderAnnouncement.vue?vue&type=template&id=394dfb4e&scoped=true"
import script from "./TenderAnnouncement.vue?vue&type=script&lang=js"
export * from "./TenderAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./TenderAnnouncement.vue?vue&type=style&index=0&id=394dfb4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394dfb4e",
  null
  
)

export default component.exports